module.exports = __webpack_public_path__ + "img/in-icon.ba9939df.svg";